import React, { useCallback, useEffect, useState } from 'react';
import { getOrgTelegramBot, updateOrgTelegramBot } from '../../services/api';
import LoadingSpinner from '../common/LoadingSpinner';

// Токен вводится и проверяется здесь же (server.py дергает getMe перед
// сохранением) — до этой формы подключить бота можно было только прямым
// запросом из консоли браузера (см. central-bani-telegram-bot).
const TelegramBotTab = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [token, setToken] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getOrgTelegramBot();
      setStatus(res);
      setEditing(!res.connected);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const submit = async (e) => {
    e.preventDefault();
    if (!token.trim()) return;
    setSaving(true);
    setError('');
    try {
      await updateOrgTelegramBot(token.trim());
      setToken('');
      setEditing(false);
      await load();
    } catch (err) {
      setError(err.response?.data?.error || 'Не удалось подключить бота');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="panel ui-settings-panel">
      <h4>Telegram-бот</h4>
      <p className="ui-settings-hint">
        Через бота гостям уходят рассылки (CRM → «Рассылки») и персональные предложения
        в Telegram, когда гость один раз поделится с ним номером телефона. У каждой организации — свой бот.
      </p>

      {status?.connected && !editing && (
        <>
          <div className="ui-status on">Подключён: @{status.bot_username}</div>
          <div className="ui-form-actions" style={{ justifyContent: 'flex-start', marginTop: 'var(--s-3)' }}>
            <a className="ui-btn-ghost" href={`https://t.me/${status.bot_username}`} target="_blank" rel="noreferrer">
              Открыть бота
            </a>
            <button type="button" className="ui-btn-ghost" onClick={() => setEditing(true)}>
              Заменить токен
            </button>
          </div>
        </>
      )}

      {editing && (
        <form className="ui-form" onSubmit={submit} style={{ marginTop: 'var(--s-3)' }}>
          {error && <div className="ui-inline-error">{error}</div>}
          <div className="ui-settings-hint">
            Токен выдаёт <a href="https://t.me/BotFather" target="_blank" rel="noreferrer">@BotFather</a> в Telegram:
            команда /newbot, затем название и username бота — в ответ придёт токен вида
            <code> 123456:AAF...</code>.
          </div>
          <div className="ui-field">
            <label>Токен бота</label>
            <input type="text" placeholder="123456789:AAExampleTokenFromBotFather"
                   value={token} onChange={(e) => setToken(e.target.value)} autoComplete="off" />
          </div>
          <div className="ui-form-actions">
            {status?.connected && (
              <button type="button" className="ui-btn-ghost" onClick={() => { setEditing(false); setError(''); }}>
                Отмена
              </button>
            )}
            <button type="submit" className="ui-btn-primary" disabled={saving || !token.trim()}>
              {saving ? 'Проверяем токен…' : 'Подключить'}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default TelegramBotTab;
